import {
  AbstractControl,
  ValidatorFn,
  FormGroup,
  FormControl,
} from '@angular/forms';

export const addValidatorsToControl = (
  control: AbstractControl<any> | null,
  validators: ValidatorFn[]
) => {
  control?.setValidators(validators);
  control?.updateValueAndValidity({ onlySelf: true });
};

export const removeFormGroupChildrenValidators = (
  formGroup: FormGroup
): void => {
  for (let controlName in formGroup.controls) {
    formGroup.get(controlName)?.clearValidators();
    formGroup.get(controlName)?.updateValueAndValidity({ onlySelf: true });
  }
  formGroup.updateValueAndValidity();
};

export const refreshFormGroupChildrenValidators = (
  formGroup: FormGroup
): void => {
  for (let controlName in formGroup.controls) {
    formGroup.get(controlName)?.updateValueAndValidity({ onlySelf: true });
  }
  formGroup.updateValueAndValidity();
};

export const removeValidators = (
  form: FormGroup,
  controlName: string
): void => {
  form.get(controlName)?.clearValidators();
  form.get(controlName)?.updateValueAndValidity({ onlySelf: true });
};

export const findControl = (
  c: AbstractControl,
  lookupInParent = false,
  control?: string
) => {
  let abstractControl: AbstractControl<any, any> | null = null;
  if (control) {
    abstractControl =
      lookupInParent && c.parent ? c.parent.get(control) : c.get(control);
  }

  return abstractControl ?? c;
};

export interface CheckboxSelectModel<T> {
  selected: FormControl<boolean | null>;
  type: FormControl<T | null>;
  label: FormControl<string | null>;
}
